export default "__VITE_ASSET__DFUgjDtU__"